import { render, staticRenderFns } from "./ManageCategory.vue?vue&type=template&id=3ba51a71"
import script from "./ManageCategory.vue?vue&type=script&lang=js"
export * from "./ManageCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports